import React from "react";
import {Row, Col} from "react-bootstrap";
import "./PatientDetail.css";
import moment from "moment";
import {
  disableHelpButton,
  enableHelpButton,
} from "../../common/DisableHelpButton/DisableHelpButton";
class PatientDetail extends React.Component {
  constructor(props) {
    super(props);
    const {app_id} = this.props.appointmentData;
    this.state = {
      appointment: app_id,
    };
  }
  componentDidMount() {
    disableHelpButton();
  }
  componentWillUnmount() {
    enableHelpButton();
  }
  render() {
    const {appointment, URL} = this.state;

    return (
      <div className="container-fluid pl-3 ">
        <Row className="mt-1 mb-3 pl-3">
          <Col className="patient-date-time p-0">
            {moment(
              new Date(
                appointment.appointment_date + " " + appointment.start_time
              )
            ).format("MMM DD, YYYY, hh:mm A")}
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="patient-title" xs={4} sm={4} md={4}>
            Purpose of Consultation
          </Col>
          <Col className="patient-content mt-0 mb-0" xs={8} sm={8} md={8}>
            {appointment.purpose_of_appointment}
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="patient-title" xs={4} sm={4} md={4}>
            Attachments
          </Col>
          <Col xs={8} sm={8} md={8} className="mt-0 mb-0">
            {(appointment.patient_prescription_url || []).map((item, i) => (
              <a
                target="_blank"
                href={item}
                className="mr-2 btn btn-info btn-sm downloadButton"
                key={i}
              >
                Download
              </a>
            ))}
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="patient-title" xs={4} sm={4} md={4}>
            Consultation type
          </Col>
          <Col className="patient-content mt-0 mb-0" xs={8} sm={8} md={8}>
            {appointment.is_follow_up === "False"
              ? "Initial Consultation"
              : "Follow up Consultation"}
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="patient-title" xs={4} sm={4} md={4}>
            Diagnosis
          </Col>
          <Col className="patient-content mt-0 mb-0" xs={8} sm={8} md={8}>
            {/* {appointment.diagnosis}               */}
            <span dangerouslySetInnerHTML={{__html: appointment.diagnosis}} />
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="patient-title" xs={4} sm={4} md={4}>
            Next Follow Up
          </Col>
          <Col className="patient-content mt-0 mb-0" xs={8} sm={8} md={8}>
            {appointment.follow_up_date !== ""
              ? moment(new Date(appointment.follow_up_date)).format(
                  "DD MMM YYYY"
                )
              : ""}
          </Col>
        </Row>
      </div>
    );
  }
}
export default PatientDetail;
